import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=6bfe8c56&scoped=true"
import script from "./activities.vue?vue&type=script&lang=ts"
export * from "./activities.vue?vue&type=script&lang=ts"
import style0 from "./activities.vue?vue&type=style&index=0&id=6bfe8c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe8c56",
  null
  
)

export default component.exports